import {
  CalendarDays,
  ChartColumn,
  Map,
  Menu,
  PhoneCall,
  Settings,
  Smartphone,
  UserCog,
  Users,
  Wallet,
  type LucideIcon,
} from 'lucide-react';

export interface NavItem {
  to: string;
  label: string;
  icon: LucideIcon;
  adminOnly?: boolean;
}

/** Bottom tab bar (phone) and the top of the rail/sidebar. */
export const PRIMARY_NAV: NavItem[] = [
  { to: '/kalendarz', label: 'Kalendarz', icon: CalendarDays },
  { to: '/do-umowienia', label: 'Do umówienia', icon: PhoneCall },
  { to: '/klienci', label: 'Klienci', icon: Users },
];

export const MORE_NAV: NavItem = { to: '/wiecej', label: 'Więcej', icon: Menu };

/** Listed on the "Więcej" screen; shown directly in the desktop sidebar. */
export const SECONDARY_NAV: NavItem[] = [
  { to: '/mapa', label: 'Mapa dnia', icon: Map },
  { to: '/nieoplacone', label: 'Nieopłacone', icon: Wallet },
  { to: '/podsumowanie', label: 'Podsumowanie', icon: ChartColumn, adminOnly: true },
  { to: '/uzytkownicy', label: 'Użytkownicy', icon: UserCog, adminOnly: true },
  { to: '/ustawienia', label: 'Ustawienia', icon: Settings },
  { to: '/instalacja', label: 'Instalacja aplikacji', icon: Smartphone },
];

export const NEW_VISIT_PATH = '/wizyty/nowa';
